import { useCallback, useEffect, useState } from "react";
import axios from "axios";
import { API_URL } from "../../config";
import { progressiveBonusDefaults } from "./progressiveBonusConfig";

function useProgressiveBonuses({ pollInterval = 0 } = {}) {
  const [bonuses, setBonuses] = useState(progressiveBonusDefaults);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState("");

  const loadBonuses = useCallback(async ({ silent = false } = {}) => {
    if (!silent) setIsLoading(true);

    try {
      const response = await axios.get(`${API_URL}/progressive-bonuses`);
      setBonuses(response.data);
      setError("");
    } catch (requestError) {
      setError("Unable to load progressive bonuses.");
    } finally {
      if (!silent) setIsLoading(false);
    }
  }, []);

  useEffect(() => {
    loadBonuses();

    if (!pollInterval) return undefined;

    const intervalId = window.setInterval(() => loadBonuses({ silent: true }), pollInterval);
    return () => window.clearInterval(intervalId);
  }, [loadBonuses, pollInterval]);

  const saveBonuses = useCallback(async (values) => {
    const response = await axios.put(`${API_URL}/progressive-bonuses`, values);
    setBonuses(response.data);
    setError("");
    return response.data;
  }, []);

  return { bonuses, error, isLoading, loadBonuses, saveBonuses };
}

export default useProgressiveBonuses;
